// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mode liste de l'affectation : tableau departement -> interlocuteur, lignes selectionnables. */
/* Remplit la cellule de visualisation (positionnee en absolu par le parent) ; scroll interne. */
.liste-affectation {
  overflow-y: auto;
  border: 1px solid #eef0f2;
  border-radius: 1rem;
}

.liste-affectation-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.25rem;
}
.liste-affectation-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f9fafb;
  text-align: left;
  padding: 0.9rem 1rem;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #595959;
  border-bottom: 1px solid #e5e7eb;
}
.liste-col-sel {
  width: 3.4rem;
  text-align: center;
}

.liste-row {
  cursor: pointer;
  transition: background 0.12s ease, opacity 0.12s ease;
}
.liste-row td {
  padding: 0.8rem 1rem;
  border-bottom: 1px solid #f1f3f5;
  color: #374151;
}
.liste-row:hover {
  background: #f9fafb;
}
.liste-row.is-selected {
  background: #fff7ed;
}
.liste-row.is-attenue {
  opacity: 0.35;
}

/* Lecture seule (apercu annuaire) : pas de selection -> colonne masquee, lignes non cliquables. */
.liste-affectation.is-readonly .liste-col-sel {
  display: none;
}
.liste-affectation.is-readonly .liste-row {
  cursor: default;
}
.liste-affectation.is-readonly .liste-row:hover {
  background: transparent;
}
.liste-col-sel input {
  cursor: pointer;
}

.liste-affecte {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}
.liste-affecte-pastille {
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.liste-non-affecte {
  font-weight: 600;
  color: #b45309;
}
`, "",{"version":3,"sources":["webpack://./src/composants/AffectationCarte/ListeAffectation.css"],"names":[],"mappings":"AAAA,gGAAgG;AAChG,gGAAgG;AAChG;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA,kGAAkG;AAClG;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* Mode liste de l'affectation : tableau departement -> interlocuteur, lignes selectionnables. */\n/* Remplit la cellule de visualisation (positionnee en absolu par le parent) ; scroll interne. */\n.liste-affectation {\n  overflow-y: auto;\n  border: 1px solid #eef0f2;\n  border-radius: 1rem;\n}\n\n.liste-affectation-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1.25rem;\n}\n.liste-affectation-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f9fafb;\n  text-align: left;\n  padding: 0.9rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #595959;\n  border-bottom: 1px solid #e5e7eb;\n}\n.liste-col-sel {\n  width: 3.4rem;\n  text-align: center;\n}\n\n.liste-row {\n  cursor: pointer;\n  transition: background 0.12s ease, opacity 0.12s ease;\n}\n.liste-row td {\n  padding: 0.8rem 1rem;\n  border-bottom: 1px solid #f1f3f5;\n  color: #374151;\n}\n.liste-row:hover {\n  background: #f9fafb;\n}\n.liste-row.is-selected {\n  background: #fff7ed;\n}\n.liste-row.is-attenue {\n  opacity: 0.35;\n}\n\n/* Lecture seule (apercu annuaire) : pas de selection -> colonne masquee, lignes non cliquables. */\n.liste-affectation.is-readonly .liste-col-sel {\n  display: none;\n}\n.liste-affectation.is-readonly .liste-row {\n  cursor: default;\n}\n.liste-affectation.is-readonly .liste-row:hover {\n  background: transparent;\n}\n.liste-col-sel input {\n  cursor: pointer;\n}\n\n.liste-affecte {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n.liste-affecte-pastille {\n  width: 1.3rem;\n  height: 1.3rem;\n  border-radius: 0.3rem;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n.liste-non-affecte {\n  font-weight: 600;\n  color: #b45309;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
